$(document).ready(function () {
  const BUILD_A_BOX_URL_PATH =
    "/a/account/custom-tools/dynamic-box?product=9822376460562";
  const BOX_SIZE_URL_PATH = "/pages/choose-schedule";

  const metaObjectToCookieMap = window.freeOffers.reduce((map, freeOffer) => {
    map.set(freeOffer.slug, freeOffer["discount_code"]);
    return map;
  }, new Map());

  const createNextPageUrl = (discountName, nextPage) =>
    `https://nettotableseafoods.com/discount/${discountName}?redirect=${nextPage}`;

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  // Listen for user's selection
  $("input[name='offer-value']").on("click", function (e) {
    var offerChoice = $("input[name='offer-value']:checked").val();

    onFreebieSelected(offerChoice);

    $(".continueButton").addClass("shake-action");
    setTimeout(function () {
      $(".continueButton").removeClass("shake-action");
    }, 1000);
  });

  function onFreebieSelected(offerChoice) {
    if (offerChoice === "affiliate") {
      // This only happens if the user has an affiliate discount code and then selects a different offer.
      // and then selects the affiliate offer again.
      localStorage.setItem("box-offer", "affiliate");
      window.discountManager.setDiscountCode("affiliate");
      // window.discountManager.clearDiscountCookie();
      // const affilateDiscount = window.discountManager.getAffilateDiscount();
      // window.discountManager.setDiscountCode(affilateDiscount);
    } else {
      const discountInfo = window.discountManager.discountCookieToInfoMap.get(offerChoice);
      localStorage.setItem("box-offer", discountInfo.name);
      window.discountManager.setDiscountCode(discountInfo.urlPath);
    }
  }

  function setupAffilateDiscountCard() {
    const affilateCard = $(".sub-select-card.affiliate");
    affilateCard.removeClass("hidden");
    const nameElem = affilateCard.find("[data-affiliate-property='name'] span");
    const descriptionElem = affilateCard.find("[data-affiliate-property='description'] span");

    descriptionElem.text("Your promotional discount will apply at checkout.");
    nameElem.text("Special Promo");

    $(".sub-select-card.affiliate input").prop(
      "checked",
      true
    );
    onFreebieSelected('affiliate');

  }

  function selectDefaultCard() {

    var free_offer_param = getUrlParameter("freeoffer"); // Is this parameter actually ever set?
    var discountCodeCookieVal = getCookie("discount_code");
    const storedBoxOffer = localStorage.getItem("box-offer");

    // Priority: URL | COOKIE | STORAGE | DEFAULT
    var defaultDiscountVal =
      free_offer_param ||
      discountCodeCookieVal ||
      metaObjectToCookieMap.get(storedBoxOffer || "") ||
      "FREEHALIBUT";
    const discountInfo = window.discountManager.discountCookieToInfoMap.get(defaultDiscountVal);
    window.discountManager.setDiscountCode(discountInfo.urlPath);
    if (discountInfo) {
      // Update the UI
      $(".sub-select-card." + (discountInfo.name || "") + " input").prop(
        "checked",
        true
      );
    }
    onFreebieSelected(window.discountManager.currentDiscount);
  }

  function setDefaults() {
    if (window.discountManager.hasAffiliateCode()) {
      setupAffilateDiscountCard();
    } else {
      selectDefaultCard();
    }

    const isBuildABox = localStorage.getItem("box-food") === "custom";

    $(".mainButtonCTA").text(
      isBuildABox ? "Continue to build-a-box" : "Continue to Box Size >>"
    );

    $(".continueButton").on("click", async function () {
      $(this)
        .find("span")
        .after(
          '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
        );

      $(this).find("span").hide();
      $(this).prop("disabled", true);

      // clear the cart b/c it might have old "freebie" products that are no longer free.
      await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      await window.discountManager.applyCurrentDiscount();

      // Add the family owens insert to the cart
      await window.NttUtils.addItemsToCart([{ id: "50989025853714", quantity: 1 }]);

      window.location = isBuildABox ? BUILD_A_BOX_URL_PATH : BOX_SIZE_URL_PATH;

    });

  }

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  $(window).on("unload", function () {
    $("#checkout-button span").show();
    $(".lds-ellipsis").remove();
    $("#checkout-button").prop("disabled", false);
  });

  setDefaults();
});
